import styled from 'styled-components';

const ModalBase = ({ children }: { children: React.ReactNode }) => {
  return <ModalWrapper>{children}</ModalWrapper>;
};

export default ModalBase;

//모달 전체  css
const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: rgba(0, 0, 0, 0.2); */
  z-index: 100;
`;
